import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AaeSelectRatingInterface } from '../../../../models/aae.model';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { filter, tap } from 'rxjs';
import { ConfirmationPopupInterface } from '../confirmation-popup/confirmation-popup.model';
import { DialogService } from '../../../../services/dialog.service';

@Component({
    selector: 'app-feedback-popup',
    templateUrl: './feedback-popup.component.html',
    styleUrl: './feedback-popup.component.scss',
})
export class FeedbackPopupComponent {
    protected feedbackRatings: FeedbackRating[] = [
        { title: '1', value: 1 },
        { title: '2', value: 2 },
        { title: '3', value: 3 },
        { title: '4', value: 4 },
        { title: '5', value: 5 },
        { title: '6', value: 6 },
        { title: '7', value: 7 },
        { title: '8', value: 8 },
        { title: '9', value: 9 },
        { title: '10', value: 10 },
    ];

    protected isShowFormError = false;
    protected selectedRating: number | null = null;

    protected form: FormGroup = this.formBuilder.group({
        message: [''],
    });

    constructor(
        private dialogService: DialogService,
        private dialogRef: MatDialogRef<FeedbackPopupComponent>,
        private formBuilder: NonNullableFormBuilder,
    ) {}

    onSubmit(): void {
        this.form.markAllAsTouched();
        this.form.controls['message'].setValue(this.form.controls['message'].value.trim());

        if (!this.selectedRating) {
            this.isShowFormError = true;

            return;
        }

        const confirmationBody: ConfirmationPopupInterface = {
            title: 'confirmation.areYouSure',
            message: 'confirmation.areYouSureWantToSubmitThisFeedback',
            cancelText: 'button.cancel',
        };

        this.dialogService
            .showConfirmationPopup(confirmationBody)
            .pipe(
                filter((isConfirm) => isConfirm),
                tap(() => {
                    const body: AaeSelectRatingInterface = {
                        rating: this.selectedRating || 0,
                        feedback: this.form.controls['message'].value,
                    };

                    this.dialogRef.close(body);
                }),
            )
            .subscribe();
    }
}

interface FeedbackRating {
    title: string;
    value: number;
}
